import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const paddingMap = {
    compact: '16px',
    default: '24px',
    spacious: '32px',
};
const statusColors = {
    received: { border: 'rgba(59, 130, 246, 0.5)', bg: 'rgba(59, 130, 246, 0.04)' },
    in_qc: { border: 'rgba(245, 158, 11, 0.5)', bg: 'rgba(245, 158, 11, 0.04)' },
    released: { border: 'rgba(0, 212, 170, 0.5)', bg: 'rgba(0, 212, 170, 0.04)' },
    quarantined: { border: 'rgba(255, 107, 107, 0.5)', bg: 'rgba(255, 107, 107, 0.04)' },
    in_use: { border: 'rgba(139, 92, 246, 0.5)', bg: 'rgba(139, 92, 246, 0.04)' },
    depleted: { border: 'rgba(107, 114, 128, 0.5)', bg: 'rgba(107, 114, 128, 0.04)' },
    retired: { border: 'rgba(107, 114, 128, 0.4)', bg: 'rgba(107, 114, 128, 0.03)' },
};
export function Card({ children, variant = 'default', status, padding = 'default', hoverable = false, style, onMouseEnter, onMouseLeave, ...props }) {
    const isInteractive = variant === 'interactive' || hoverable;
    const isStatus = variant === 'status' && status;
    const isElevated = variant === 'elevated';
    const statusColor = isStatus ? statusColors[status] : null;
    const baseStyle = {
        background: 'var(--glass-surface, rgba(17,17,19,0.72))',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        border: `1px solid ${statusColor ? 'transparent' : 'var(--glass-border-color, rgba(255,255,255,0.06))'}`,
        borderRadius: 'var(--radius-lg)',
        padding: paddingMap[padding],
        transition: 'transform 150ms cubic-bezier(0.22,1,0.36,1), box-shadow 150ms cubic-bezier(0.22,1,0.36,1), border-color 150ms cubic-bezier(0.22,1,0.36,1)',
        cursor: isInteractive ? 'pointer' : undefined,
        boxShadow: isElevated
            ? 'var(--shadow-card-elevated, 0 8px 32px rgba(0,0,0,0.5))'
            : 'var(--shadow-card, 0 1px 3px rgba(0,0,0,0.3))',
        position: 'relative',
        overflow: 'hidden',
        // Status: subtle background tint
        ...(statusColor && {
            background: statusColor.bg,
        }),
        ...style,
    };
    return (_jsxs("div", { style: baseStyle, onMouseEnter: (e) => {
            if (isInteractive) {
                const el = e.currentTarget;
                el.style.transform = 'translateY(-2px)';
                el.style.boxShadow = 'var(--shadow-card-hover, 0 8px 32px rgba(0,0,0,0.4))';
                el.style.borderColor = 'var(--glass-border-color-hover, rgba(255,255,255,0.10))';
            }
            onMouseEnter?.(e);
        }, onMouseLeave: (e) => {
            if (isInteractive) {
                const el = e.currentTarget;
                el.style.transform = 'translateY(0)';
                el.style.boxShadow = isElevated ? 'var(--shadow-card-elevated)' : 'var(--shadow-card)';
                el.style.borderColor = statusColor ? 'transparent' : 'var(--glass-border-color)';
            }
            onMouseLeave?.(e);
        }, ...props, children: [isStatus && statusColor && (_jsx("span", { "aria-hidden": "true", style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: '4px',
                    background: statusColor.border.replace('0.5)', '0.8)'),
                    borderRadius: '0',
                    pointerEvents: 'none',
                } })), isStatus && statusColor && (_jsx("span", { "aria-hidden": "true", style: {
                    position: 'absolute',
                    inset: 0,
                    borderRadius: 'var(--radius-lg)',
                    border: `1px solid ${statusColor.border}`,
                    pointerEvents: 'none',
                } })), children] }));
}
/** Horizontal divider for use inside a Card */
export function CardDivider({ style }) {
    return (_jsx("hr", { "aria-hidden": "true", style: {
            border: 'none',
            borderTop: '1px solid var(--glass-border-color, rgba(255,255,255,0.06))',
            margin: '0 calc(-1 * var(--space-6))',
            ...style,
        } }));
}
/** Header section inside a Card — applies bottom border + spacing */
export function CardHeader({ children, style }) {
    return (_jsx("div", { style: {
            paddingBottom: 'var(--space-4)',
            marginBottom: 'var(--space-4)',
            borderBottom: '1px solid var(--glass-border-color, rgba(255,255,255,0.06))',
            ...style,
        }, children: children }));
}
//# sourceMappingURL=Card.js.map